import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

type FeatureFlagArgs = {
  venueId: string | undefined;
  country: Country | undefined;
  merchantId: string | undefined;
  enabled: boolean;
};

export const useIsAdsFreeTrialsFeatureFlagEnabled = ({ venueId, country, merchantId, enabled }: FeatureFlagArgs) => {
  const { user } = useUser();
  const userId = user?.id || '';

  const featureFlagName = 'merchant-ads-free-trials';

  const eligibilityCriteria = {
    user_id: userId,
    country: country ?? '',
    venue_id: venueId ?? '',
    merchant_id: merchantId ?? '',
  };

  const {
    data: featureFlags,
    isLoading,
    isFetching,
  } = useFeatureFlags(
    [featureFlagName],
    {
      ...eligibilityCriteria,
    },
    { enabled },
  );

  return {
    isLoading: isLoading && isFetching,
    isAdsFreeTrialsEnabled: featureFlags?.[featureFlagName] === 'on',
  };
};
